var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5672 4.52628C26.9131 3.69768 28.087 3.69768 28.4329 4.52628L34.2877 18.5515C34.426 18.8827 34.7294 19.1157 35.085 19.1638L50.4004 21.2367C51.2767 21.3553 51.589 22.4625 50.9039 23.0216L39.0315 32.7099C38.733 32.9535 38.5989 33.3456 38.6858 33.721L42.4845 50.1365C42.6936 51.0397 41.6778 51.7244 40.919 51.1918L28.0808 42.1812C27.7323 41.9366 27.2679 41.9366 26.9194 42.1812L14.0811 51.1918C13.3223 51.7244 12.3066 51.0398 12.5156 50.1365L16.314 33.7209C16.4009 33.3456 16.2668 32.9535 15.9683 32.7099L4.09622 23.0216C3.41109 22.4625 3.72344 21.3553 4.59976 21.2367L19.9152 19.1638C20.2708 19.1157 20.5742 18.8827 20.7124 18.5515L26.5672 4.52628Z",
    stroke: "#84BD86",
    strokeWidth: 4.04348,
    strokeMiterlimit: 3.3292,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.aa506b94348ddb2f51023a8068030e05.svg";
export { ForwardRef as ReactComponent };